import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WikiComponent } from './wiki.component';
import { EditorContainerComponent } from './editor-container/editor-container.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { ReorderContainerComponent } from './reorder-container/reorder-container.component';
import { BkoGuard } from 'app/shared/guards/bko.guard';
import { AuthGuard } from 'app/shared/guards/auth.guard';

const routes: Routes = [
    {
        path: '',
        component: WikiComponent,
        canActivateChild: [AuthGuard],
        children: [
            {path: 'file/:path', component: EditorContainerComponent, data: { title: 'main.nav.links.wiki' }},
            {path: 'file', component: EditorContainerComponent, data: { title: 'main.nav.links.wiki' }},
            {path: 'search', component: SearchResultComponent, data: { title: 'main.nav.links.wiki' }},
            {path: 'reorder', component: ReorderContainerComponent, canActivate: [BkoGuard], data: { title: 'main.nav.links.wiki' }},
            {path: '', redirectTo: 'file', pathMatch: 'full', data: { title: 'main.nav.links.wiki' }},
        ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WikiRoutingModule { }
